// import moment from 'moment';
// import 'moment-timezone';

export default function (store) {
  store.subscribe((mutation) => {
    if (mutation.type === 'entities/users/loginSuccess' || mutation.type === 'entities/users/validateTokenSuccess') {
      // const currentUser = store.getters['entities/users/currentUser'];

      // if (currentUser.timezone) {
      //   moment.tz.setDefault(currentUser.timezone);
      // }
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/plugins/timezone.js